<template>
  <span id="topicsViewPlaceholder" @click="click">
    <select ref="select" multiple>
      <option
        v-for="(tag, i) in value"
        :key="i"
        selected="selected"
        :value="tag"
      >
        {{ tag }}
      </option>
    </select>
  </span>
</template>

<script>
import app from 'app';
import $ from 'jquery';
import 'selectize';
export default {
  data: () => ({
    selectize: null,
  }),
  props: ['value'],
  async mounted() {
    await this.$nextTick();
    this.selectize = $(this.$refs.select).selectize({
      placeholder: app.culture.metadataEditor.tagsEmpty,
      delimiter: ',',
      persist: false,
      create: function (input) {
        return {
          value: input,
          text: input,
        };
      },
      render: {
        item: function (data, escape) {
          return (
            '<div class="topic item">' +
            escape(data[$.fn.selectize.defaults.labelField]) +
            '  <i class="delete-tag wticon wticon-cross2"></i></div>'
          );
        },
      },
      onChange: (value) => {
        this.$emit('input', value);
      },
    });
  },
  methods: {
    click(e) {
      if (e.target.classList.value.split(' ').includes('delete-tag')) {
        const removeItemValue = e.target.parentElement.dataset.value;
        this.selectize[0].selectize.removeItem(removeItemValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
